module.exports = {"Opensalud":["/static-appopensalud/gtags/gtag-opensaludes.js"],"opensalud":["/static-appopensalud/gtags/gtag-opensaludes.js"],"Opensalud 360":["/static-appopensalud/gtags/gtag-opensaludes.js"],"opensalud360":["/static-appopensalud/gtags/gtag-opensaludes.js"],"Opensaludprime":["https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y","/static-appopensalud/gtags/gtag-primesalud.js"],"opensaludprime":["https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y","/static-appopensalud/gtags/gtag-primesalud.js"]}


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/gtags.json
// module id = 2017
// module chunks = 116